/* global axios */

import ApiClient from './ApiClient';

class IntegrationsAPI extends ApiClient {
  constructor() {
    super('integrations/apps', { accountScoped: true });
  }

  connectSlack(code) {
    return axios.post(`${this.baseUrl()}/integrations/slack`, { code });
  }

  updateSlack({ referenceId }) {
    return axios.patch(`${this.baseUrl()}/integrations/slack`, {
      reference_id: referenceId,
    });
  }

  listAllSlackChannels() {
    return axios.get(`${this.baseUrl()}/integrations/slack/list_all_channels`);
  }

  delete(integrationId) {
    return axios.delete(`${this.baseUrl()}/integrations/${integrationId}`);
  }

  createHook(hookData) {
    return axios.post(`${this.baseUrl()}/integrations/hooks`, hookData);
  }

  deleteHook(hookId) {
    return axios.delete(`${this.baseUrl()}/integrations/hooks/${hookId}`);
  }

  showHook(hookId) {
    return axios.get(`${this.baseUrl()}/integrations/hooks/${hookId}`);
  }

  updateHook(hookId, settings) {
    return axios.patch(`${this.baseUrl()}/integrations/hooks/${hookId}`, {
      hook: { settings },
    });
  }

  getDefaultSummaryPrompt(hookId) {
    return axios.get(
      `${this.baseUrl()}/integrations/hooks/${hookId}/default_summary_prompt`
    );
  }

  requestCaptain(body) {
    return axios.post(`${this.baseUrl()}/integrations/captain/proxy`, body);
  }

  requestCaptainCopilot(body) {
    return axios.post(`${this.baseUrl()}/integrations/captain/copilot`, body);
  }

  getCaptainCopilotHistory(conversationId) {
    return axios.get(`${this.baseUrl()}/integrations/captain/copilot_history`, {
      params: { conversation_id: conversationId },
    });
  }

  resetCaptainCopilotHistory(conversationId) {
    return axios.delete(
      `${this.baseUrl()}/integrations/captain/copilot_history`,
      {
        params: { conversation_id: conversationId },
      }
    );
  }

  getInboxCopilotHistory(inboxId) {
    return axios.get(`${this.baseUrl()}/integrations/captain/copilot_history`, {
      params: { inbox_id: inboxId, email_inbox_scope: true },
    });
  }

  resetInboxCopilotHistory(inboxId) {
    return axios.delete(
      `${this.baseUrl()}/integrations/captain/copilot_history`,
      { params: { inbox_id: inboxId, email_inbox_scope: true } }
    );
  }

  updateInboxCopilotTemporalScope(inboxId, temporalScope) {
    return axios.patch(
      `${this.baseUrl()}/integrations/captain/copilot_inbox_temporal_scope`,
      {
        inbox_id: inboxId,
        email_inbox_scope: true,
        temporal_scope: temporalScope,
      }
    );
  }
}

export default new IntegrationsAPI();
